<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path d="M9 4C9.41421 4 9.75 4.33579 9.75 4.75V8.25H13.25C13.6642 8.25 14 8.58579 14 9C14 9.41421 13.6642 9.75 13.25 9.75H9.75V13.25C9.75 13.6642 9.41421 14 9 14C8.58579 14 8.25 13.6642 8.25 13.25V9.75H4.75C4.33579 9.75 4 9.41421 4 9C4 8.58579 4.33579 8.25 4.75 8.25H8.25V4.75C8.25 4.33579 8.58579 4 9 4ZM0 3.25C0 1.45507 1.45507 0 3.25 0H14.75C16.5449 0 18 1.45507 18 3.25V14.75C18 16.5449 16.5449 18 14.75 18H3.25C1.45507 18 0 16.5449 0 14.75V3.25ZM3.25 1.5C2.2835 1.5 1.5 2.2835 1.5 3.25V14.75C1.5 15.7165 2.2835 16.5 3.25 16.5H14.75C15.7165 16.5 16.5 15.7165 16.5 14.75V3.25C16.5 2.2835 15.7165 1.5 14.75 1.5H3.25Z" />
  </svg>
</template>
